import { atom, useAtom, useSetAtom, useAtomValue } from "jotai";
import { atomFamily } from "jotai/utils";
import type { GridApi } from "ag-grid-community";

import { DEFAULT_PANE_ID, usePaneId, useSoleGridPaneId } from "../../pane/context";

export const gridApiAtomFamily = atomFamily((_paneId: string) => atom<GridApi | null>(null));
export const focusedPaneIdAtom = atom<string>(DEFAULT_PANE_ID);

/*
 * TODO! REMOVE WITH the single-grid shim in pane/context.tsx, leaving `usePaneId()`.
 * Chrome outside every pane reads the DEFAULT slot while the grid registers under
 * its own pane, so it would see no api at all and its handlers would no-op.
 */
const useGridPaneId = () => {
  const paneId = usePaneId();
  const soleGridPaneId = useSoleGridPaneId();
  return paneId === DEFAULT_PANE_ID ? (soleGridPaneId ?? paneId) : paneId;
};

export const useGrid = () => useAtom(gridApiAtomFamily(useGridPaneId()));
export const useSetGrid = () => useSetAtom(gridApiAtomFamily(usePaneId()));

export const suppressHeaderTooltipsAtom = atom<boolean>(false);
export const useSuppressHeaderTooltips = () => useAtom(suppressHeaderTooltipsAtom);
export const useSetSuppressHeaderTooltips = () => useSetAtom(suppressHeaderTooltipsAtom);
export const useShouldSuppressHeaderTooltips = () => useAtomValue(suppressHeaderTooltipsAtom);
